module.exports = __webpack_public_path__ + "img/lock.edab6651.svg";